import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import useAnalytics from "../hooks/useAnalytics";

export default function Layout({ children }) {
    // Anonymous pageview tracking — never throws.
    useAnalytics();
    return (
        <div className="min-h-screen bg-obsidian text-white flex flex-col">
            <Nav />
            <main className="flex-1 pt-20">{children}</main>
            <Footer />
        </div>
    );
}
